import React, { useContext, useState } from 'react';

import { Input } from 'components/bootstrap';
import Select from 'components/common/Select';

import FormAdvancedOptions from './FormAdvancedOptions';
import { FormDataContext } from './context/FormData';
import INITIAL_FORMDATA from './_initialFormData';
import type { ErrorMessageType, FormDataContextType, HandleFieldUpdateType, HandleSubmitType } from './types';

import FormWrap from '../common/FormWrap';

interface Props {
  onSubmit: HandleSubmitType;
  onChange: HandleFieldUpdateType;
}

const StepSubscribe = ({ onSubmit, onChange }: Props) => {
  const { formData } = useContext<FormDataContextType>(FormDataContext);
  const [formError, setFormError] = useState<ErrorMessageType>(null);
  const { pollingInterval } = formData;

  const availableContent = [
    { label: 'Global Traffic', value: 'GTM' },
    { label: 'Local Traffic', value: 'LTM' },
    { label: 'Mail logs', value: 'MAIL' },
    { label: 'Security', value: 'SECURITY' },
    { label: 'Traffic Manager Microkernel', value: 'TMM' },
    { label: 'User process', value: 'USER' },
    { label: 'Application messages', value: 'MESSAGES' },
    { label: 'Audit ', value: 'AUDIT' },
    { label: 'Daemon', value: 'DAEMON' },
    { label: 'Kernel', value: 'KERNEL' },
    { label: 'Webui', value: 'WEBUI' },
  ];

  const [contentTypes, setContentTypes] = useState<string>(INITIAL_FORMDATA.availableContents.value);

  const handleSubmit = () => {
    let error = false;
    formData.content_type.value = contentTypes;

    if (pollingInterval.value < 1) {
      setFormError({
        full_message: 'Please provide valid polling interval',
        nice_message: 'Minimum allowable polling interval is 1 minute.',
      });

      error = true;
    }

    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };

  return (
    <FormWrap onSubmit={handleSubmit} buttonContent="Proceed" title="" error={formError} description="">
      <label className="control-label" htmlFor="contents">
        Logs Types to Collect
      </label>
      <Select
        multi
        name="content_type"
        id="content_type"
        onChange={(selected: string) => setContentTypes(selected)}
        options={availableContent}
        value={contentTypes}
        matchProp="label"
      />
      <span className="help-block">The activity log for the above content types will be fetched.</span>
      <Input
        id="pollingInterval"
        name="pollingInterval"
        type="number"
        value={pollingInterval.value || pollingInterval.defaultValue || ''}
        min="1"
        max="60"
        step="1"
        onChange={onChange}
        required
        help="Determines how often (in minutes) new data will be checked for in F5. The smallest allowable interval is 1 minute."
        label="Polling Interval"
      />

      <FormAdvancedOptions onChange={onChange} />
    </FormWrap>
  );
};

export default StepSubscribe;
